import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import { MESSAGEDETAIL_TYPES } from 'src/constants/constants';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import { getCaseMessagesCountsPending } from 'src/ui/features/Cases/state/casesActions';
import { deleteMessages, selectDetailView, assignCaseToMessage, downloadAttachment } from '../state/messagingActions';
import ViewMsgPres from '../presentational/ViewMsgPres';
import { checkIsComposeView, getMessages, getFilters, getMeta, getMessageShown } from 'src/ui/features/Messaging/state/messagingReselect';
import { MESSAGEBOX_VIEWS, AUTOCOMPLETE_MESSAGING_CASES_LIMIT } from 'src/constants/constants';
import { toggleDrawer } from 'src/utils/utilsActions';
import { withSnackbar } from 'notistack';
import { searchCases } from 'src/services/messages.service';

class DetailContainer extends Component {
  static propTypes = {
    filters: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    messages: PropTypes.array.isRequired,
    selectedMenu: PropTypes.string.isRequired,
    deleteMessages: PropTypes.func.isRequired,
    enqueueSnackbar: PropTypes.func,
  };

  state = {
    showModal: false,
    id: null,
    caseSelected: false,
    caseId: null,
  };

  componentDidMount() {
    this.setState({ caseId: this.props.caseId });
    getCaseMessagesCountsPending();
  }

  showConfirm = id => {
    this.setState({ showModal: true, id });
  };

  hideConfirm = () => {
    this.setState(prevState => ({ showModal: !prevState.showModal }));
  };

  deleteMessage = () => {
    const { deleteMessages, selectedMenu, enqueueSnackbar, getCaseMessagesCountsPending } = this.props;
    getCaseMessagesCountsPending();
    this.hideConfirm();
    deleteMessages(selectedMenu, this.state.id, () =>
      enqueueSnackbar(intl.get('messaging.notifications.messageDeleted'), { variant: 'success' }),
    );
  };

  onCancel = () => {
    this.props.switchView(MESSAGEBOX_VIEWS.LIST);
  };

  handleAction(type) {
    this.props.selectDetailView(type);

    if (this.props.isMobile) this.props.toggleDrawer('right');

    return true;
  }

  toggleCaseInput = e => {
    if (e) {
      e.stopPropagation();
    }
    this.setState(prevState => ({ caseSelected: !prevState.caseSelected }));
  };

  onRequestCases = val => {
    if (!val) {
      return Promise.resolve({});
    }
    return searchCases(val, AUTOCOMPLETE_MESSAGING_CASES_LIMIT, this.props.isApplicant).then(result => {
      const data = result.casesList.map((row, index) => ({ ...row, index }));
      return data;
    });
  };

  handleUpdateField = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  handleAssignToCase = () => {
    const { messageData } = this.props;
    const caseId = this.state.caseId ? this.state.caseId : null;
    const payload = {
      messageId: messageData.id,
      caseId: caseId,
    };

    this.props.assignCaseToMessage(payload);
    this.toggleCaseInput(null);
    this.setState({ caseId: null });
  };

  // downloadAttachment = i => {
  //   const { messageData } = this.props;
  //   const payload = {
  //     messageId: messageData.attachments[i].messageId,
  //     attachmentId: messageData.attachments[i].id,
  //   };
  //   this.props.downloadAttachment(payload);
  // };

  downloadAttachment = index => {
    const { attachments } = this.props.messageData;
    const linkSource = `data:${attachments[index].mimetype};base64,${attachments[index].documentbody}`;
    const downloadLink = document.createElement('a');
    const fileName = attachments[index].filename;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  componentDidUpdate(prevProps) {
    const { messageData } = this.props;
    if (prevProps.messageData && messageData && prevProps.messageData.id !== messageData.id) {
      this.setState({ caseSelected: false });
    }
  }

  render() {
    const { messageData } = this.props;

    if (messageData && messageData.from === undefined) return false;

    return (
      <Fragment>
        {this.state.showModal && (
          <ConfirmDialog
            open
            title={intl.get('messaging.confirmDelete.title')}
            cancelText={intl.get('messaging.confirmDelete.cancel')}
            confirmText={intl.get('messaging.confirmDelete.delete')}
            onCancel={this.hideConfirm}
            onConfirm={this.deleteMessage}>
            <span>{intl.get('messaging.confirmDelete.messageText')}</span>
          </ConfirmDialog>
        )}
        <ViewMsgPres
          {...this.props}
          selectedMenu={this.props.selectedMenu}
          onForward={this.handleAction.bind(this, MESSAGEDETAIL_TYPES.FORWARD)}
          onReply={this.handleAction.bind(this, MESSAGEDETAIL_TYPES.REPLY)}
          onReplyToAll={this.handleAction.bind(this, MESSAGEDETAIL_TYPES.REPLY_TO_ALL)}
          showConfirm={this.showConfirm}
          onCancel={this.onCancel}
          caseSelected={this.state.caseSelected}
          onFieldUpdate={this.handleUpdateField}
          onRequestCases={this.onRequestCases}
          handleAssignToCase={this.handleAssignToCase}
          downloadAttachment={this.downloadAttachment}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  messages: getMessages(state),
  filters: getFilters(state),
  meta: getMeta(state),
  messageData: getMessageShown(state),
  selectedMenu: state.messaging.selectedMenu,
  isMobile: state.browser.is.small || state.browser.is.extraSmall,
  isComposeView: checkIsComposeView(state),
  isApplicant: state.login.userRoles.applicant,
  isCorpClient: state.login.userRoles.corpClient,
  isEyPro: state.login.userRoles.eyPro,
  caseId: state.cases.caseId,
});

const mapDispatchToProps = {
  deleteMessages,
  selectDetailView,
  toggleDrawer,
  assignCaseToMessage,
  downloadAttachment,
  getCaseMessagesCountsPending,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(DetailContainer));
